import React from 'react';
import cx from 'classnames';

import { useData } from './hooks';
import './ValidationMessage.scss';


const ValidationMessage = ({
  className,
  description = null,
  animationSpeed = 150,
}) => {
  const {
    text,
    isHiding,
    isShowing,
  } = useData(description, animationSpeed);

  const classNames = cx('validationMessage', className, {
    'validationMessage--hide': isHiding,
    'validationMessage--show': isShowing,
  });

  return (
    <span className={classNames} style={{ animationDuration: `${animationSpeed}ms` }}>
      {text}
    </span>
  );
};

export default ValidationMessage;
